var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[_vm.alternative && 'alt']},[_vm._v(" Copyright © "+_vm._s(_vm.year)+" SERTRACEN Panamá. Todos los derechos reservados ")])}
var staticRenderFns = []

export { render, staticRenderFns }